import React, { useState, useContext } from "react";
import { Link as RouterLink, withRouter } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Hidden from '@material-ui/core/Hidden';

import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  link: {
    '&:hover': {
      color: theme.palette.type==='dark'?theme.palette.primary.main:theme.palette.primary.main
    }
  }
}))

const Link = to => ({...rest}) => {
  return <RouterLink to={to} {...rest}/>
}

export const ResponsiveIconButton = (props) => {
  const {startIcon, children, ...rest} = props;
  return <>
    <Hidden smUp implementation="css">
      <IconButton {...rest}>{startIcon}</IconButton>
    </Hidden>
    <Hidden xsDown implementation="css">
      <Button startIcon={startIcon} {...rest}>{children}</Button>
    </Hidden>
  </>
}

export const LinkButton = withRouter((props) => {
  const classes = useStyles();
  const { to, activeLink, activeColor='secondary', color='default', match, location, responsive=false,...rest } = props;
  const matchLink = activeLink || to;
  const active = matchLink === location.pathname;
  const component = Link(to);
  if (responsive)
    return <ResponsiveIconButton className={classes.link} color={active?activeColor:color} component={component} {...rest} />
  return <Button className={classes.link} color={active?activeColor:color} component={component} {...rest} />
})

